module.exports = __webpack_public_path__ + "static/placeholder-aa94bcf01cfee68897ef159a3331057e.png";